// extracted by mini-css-extract-plugin
module.exports = {"desktop":"KpiTable_desktop__1oxGM","mobile":"KpiTable_mobile__37Y71","status":"KpiTable_status__2wtl8","info":"KpiTable_info__39pWS"};